import { menuBarGame, menuBarGameMobile, menuBannerGamesMobile } from '~/resources/lobby-games/menu-category'
import { LABEL_OTHER_GAME } from '~/constants'
import { CATEGORY_GAME_SLUG } from '~resources/lobby-games/urls'
import type { CurrentCategory, MenuLobbyItem } from '~composables/lobby-games/interface'

export function useCommonLobbyGames() {
  const { isMobile } = useDevice()

  const tabDefault = menuBarGame[0].category ?? CATEGORY_GAME_SLUG.NOHU
  const menuLobbyGames = isMobile ? Array<MenuLobbyItem>(...menuBarGameMobile) : Array<MenuLobbyItem>(...menuBarGame)
  const menuBannerGames = Array<MenuLobbyItem>(...menuBannerGamesMobile)

  // get current category
  const gameType = ref(tabDefault)
  const currentCategory = reactive<CurrentCategory>({ title: menuBarGame[0].title, slug: tabDefault })

  const updateGameType = (tab: string): void => {
    gameType.value = tab || tabDefault
    const category = menuLobbyGames.find(item => item.category === gameType.value)
    currentCategory.title = category?.title ?? LABEL_OTHER_GAME
    currentCategory.slug = category?.category?.toString() ?? ''
  }

  return {
    gameType,
    menuLobbyGames,
    updateGameType,
    currentCategory,
    menuBannerGames
  }
}
